module.exports = "/images/logo_sdac_cn.png?2f6c380eafeca92e87a8f430df4554d7";